import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";
import { UPDATE_TYPE, backendQueryKey as keyFactoryBackendQueryKey } from "utils/keyFactory";

import type { Dealer, Webhook, WebhookError, WebhookTrigger } from "models";
import type { PaginatedItems } from "utils/paginatedItems";

const component = "WebhooksDashboard";

export const WebhooksQueryKeys = {
  webhooks: backendQueryKey<Webhook[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/webhooks/list" }),
  errors: backendQueryKey<PaginatedItems<WebhookError>>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/webhooks/errors/list" }),
  triggers: backendQueryKey<WebhookTrigger[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/webhooks/triggers/list" }),
  dealerChecklists: backendQueryKey<Dealer>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/dealers/details", params: { embed: "checklist" } }),
  locationChecklist: (id: number) =>
    keyFactoryBackendQueryKey({
      component,
      baseUrl: ENV.dealerBaseURL,
      endpoint: "/locations/details",
      params: { embed: "checklist", id },
      updateType: UPDATE_TYPE.Static
    })
};
